import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFlowr = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -2 20 26",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M-1 0h20v26H-1z",
		style: { fill: "#ff6786" }
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0 .33V23.4h5.25V13.02h8.44v-2.71H5.25V3.03h11.3V.33z",
		style: { fill: "#fff" }
	})]
});
export default SvgIconFlowr;
